/** Event properties for "knapp klikket" analytics events */
export const knappKlikket = {
  oversiktSide: {
    lagNyOppfolgingsplan: {
      komponentId: "lag-ny-oppfolgingsplan-knapp",
      tekst: "Lag en ny oppfølgingsplan",
      kontekst: "OversiktSide",
    },
    slettUtkastModalTrigger: {
      komponentId: "slett-utkast-modal-trigger-knapp",
      tekst: "Slett utkast",
      kontekst: "OversiktSide",
    },
    slettUtkastModal: {
      bekreft: {
        komponentId: "slett-utkast-modal-bekreft-knapp",
        tekst: "Slett utkast",
        kontekst: "OversiktSide-SlettUtkastModal",
      },
      avbryt: {
        komponentId: "slett-utkast-modal-avbryt-knapp",
        tekst: "Avbryt",
        kontekst: "OversiktSide-SlettUtkastModal",
      },
    },
  },
  nyPlanSide: {
    fyllUtSteg: {
      avsluttOgFortsettSenere: {
        komponentId: "avslutt-og-fortsett-senere-knapp",
        tekst: "Avslutt og fortsett senere",
        kontekst: "NyPlanSide-FyllUtPlanSteg",
      },
    },
    oppsummeringSteg: {
      gaTilbake: {
        komponentId: "ga-tilbake-fra-oppsummering-knapp",
        tekst: "Gå tilbake",
        kontekst: "NyPlanSide-OppsummeringSteg",
      },
      avsluttOgFortsettSenere: {
        komponentId: "avslutt-og-fortsett-senere-knapp",
        tekst: "Avslutt og fortsett senere",
        kontekst: "NyPlanSide-OppsummeringSteg",
      },
    },
  },
  ferdigstiltPlanSide: {
    visPdfSykmeldt: {
      komponentId: "vis-pdf-knapp-sykmeldt",
      tekst: "Vis PDF",
      kontekst: "FerdigstiltPlanSideSykmeldt",
    },
    visPdfArbeidsgiver: {
      komponentId: "vis-pdf-knapp-arbeidsgiver",
      tekst: "Vis PDF",
      kontekst: "FerdigstiltPlanSideArbeidsgiver",
    },
    tilbakeTilOversikt: {
      komponentId: "tilbake-til-oversikt-knapp",
      tekst: "Tilbake til oppfølgingsplaner",
      kontekst: "FerdigstiltPlanSide",
    },
  },
  aktivPlanSide: {
    endreOppfolgingsplan: {
      komponentId: "endre-oppfolgingsplan-knapp",
      tekst: "Endre oppfølgingsplanen",
      kontekst: "AktivPlanSide",
    },
    lagNyOppfolgingsplan: {
      komponentId: "lag-ny-oppfolgingsplan-knapp",
      tekst: "Lag en ny plan",
      kontekst: "AktivPlanSide",
    },
    delMedFastlege: {
      komponentId: "del-med-fastlege-knapp",
      tekst: "Send til fastlege",
      kontekst: "AktivPlanSide",
    },
    delMedVeileder: {
      komponentId: "del-med-nav-knapp",
      tekst: "Send til Nav-veileder",
      kontekst: "AktivPlanSide",
    },
    overskriveUtkastForAEndreModal: {
      bekreft: {
        komponentId: "erstatt-utkast-og-fortsett-knapp",
        tekst: "Erstatt utkast og fortsett",
        kontekst: "AktivPlanSide-OverskriveUtkastForAEndreModal",
      },
      avbryt: {
        komponentId: "avbryt-erstatt-utkast-knapp",
        tekst: "Avbryt",
        kontekst: "AktivPlanSide-OverskriveUtkastForAEndreModal",
      },
    },
    sletteUtkastForALageNyModal: {
      bekreft: {
        komponentId: "slett-utkast-og-fortsett-knapp",
        tekst: "Slett utkast og fortsett",
        kontekst: "AktivPlanSide-SletteUtkastForALageNyModal",
      },
      avbryt: {
        komponentId: "avbryt-slett-utkast-knapp",
        tekst: "Avbryt",
        kontekst: "AktivPlanSide-SletteUtkastForALageNyModal",
      },
    },
  },
};
